import { useEffect, useState } from "react";
import { listTradeOffers, updateTradeOffer } from "../api/tradesApi";
import { mediaUrl } from "../utils/listingPresentation";

export function TradeItem({ listing, label }) {
  return <div className="trade-item">
    {listing?.primary_image_url ? <img src={mediaUrl(listing.primary_image_url)} alt="" /> : <div className="trade-item-placeholder">Intet billede</div>}
    <strong>{listing?.title || "Vælg din vare"}</strong><small>{label}</small>
  </div>;
}

export default function TradeOffers({ apiUrl, auth, onOpenConversation, refreshKey = 0, compact = false }) {
  const [offers, setOffers] = useState([]);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState("");
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState("received");
  const token = auth?.access_token;
  const userId = auth?.user?.id;
  useEffect(() => {
    if (!token) return;
    let active = true;
    async function load() {
      try {
        const result = await listTradeOffers({ apiUrl, accessToken: token });
        if (active) { setOffers(result); setError(""); }
      } catch { if (active) setError("Byttetilbud kunne ikke hentes. Prøv igen om lidt."); }
      finally { if (active) setLoading(false); }
    }
    setOffers([]); setLoading(true); load();
    const timer = setInterval(load, 30000);
    return () => { active = false; clearInterval(timer); };
  }, [apiUrl, token, refreshKey]);

  async function change(offer, status) {
    if (!window.confirm(status === "declined" ? "Vil du afvise dette byttetilbud?" : "Vil du trække dit byttetilbud tilbage?")) return;
    setBusy(offer.id); setError("");
    try {
      const updated = await updateTradeOffer({ apiUrl, accessToken: token, offerId: offer.id, status });
      setOffers(current => current.map(item => item.id === offer.id ? updated : item));
    } catch (err) { setError(typeof err.response?.data?.detail === "string" ? err.response.data.detail : "Tilbuddet kunne ikke ændres."); }
    finally { setBusy(""); }
  }
  if (!token) return null;
  const received = offers.filter(offer => offer.recipient.id === userId && offer.status === "pending");
  const shown = compact ? received.slice(0, 1) : offers.filter(offer => tab === "received" ? offer.recipient.id === userId : offer.sender.id === userId);
  if (compact && !shown.length) return null;
  return <section className="trade-offers" aria-label="Dine byttetilbud">
    {!compact && <div className="section-toolbar"><h2>Dine byttetilbud</h2><div className="category-tabs">
      <button type="button" className={tab === "received" ? "active" : ""} onClick={() => setTab("received")}>Modtaget ({received.length})</button>
      <button type="button" className={tab === "sent" ? "active" : ""} onClick={() => setTab("sent")}>Sendt</button>
    </div></div>}
    {error && <p role="alert" className="status-line error">{error}</p>}
    {!compact && loading && <p role="status">Henter byttetilbud…</p>}
    {!compact && !loading && !error && !shown.length && <p className="trade-empty">Ingen byttetilbud endnu. Når nogen foreslår et bytte, kan I aftale detaljerne i beskeder.</p>}
    {shown.map(offer => {
      const incoming = offer.recipient.id === userId;
      const other = incoming ? offer.sender : offer.recipient;
      return <article className="trade-offer" key={offer.id}>
        <div className="trade-offer-heading">
          <span className="trade-avatar" aria-hidden="true">{other.display_name.slice(0, 1)}</span>
          <div><strong>{other.display_name}</strong><p>{incoming ? "har sendt dig et byttetilbud" : "har modtaget dit byttetilbud"}</p></div>
          <time dateTime={offer.created_at}>{new Date(offer.created_at).toLocaleDateString("da-DK")}</time>
        </div>
        <div className="trade-offer-body">
          <div className="trade-pair"><TradeItem listing={offer.offered_listing} label={incoming ? "De har" : "Du har"} /><span className="trade-arrow" aria-label="byttes med">⇄</span><TradeItem listing={offer.target_listing} label={incoming ? "Du har" : "De har"} /></div>
          <div className="trade-offer-message"><p>{offer.message}</p>
            {(offer.offered_listing.status !== "active" || offer.target_listing.status !== "active") && <p className="status-line">En af annoncerne er ikke længere aktiv.</p>}
            {offer.status !== "pending" && <strong className="trade-badge">{offer.status === "declined" ? "Afvist" : "Trukket tilbage"}</strong>}
            <div className="trade-actions">
              {offer.status === "pending" && <button type="button" className="secondary-action" disabled={busy === offer.id} onClick={() => change(offer, incoming ? "declined" : "withdrawn")}>{busy === offer.id ? "Gemmer…" : incoming ? "Afvis" : "Træk tilbage"}</button>}
              <button type="button" className="primary-action" onClick={() => onOpenConversation(offer.conversation_id)}>Se besked</button>
            </div>
          </div>
        </div>
      </article>;
    })}
  </section>;
}
